/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Save_P2Inputs */

const en_wc_tut_save_p2 = /** @type {(inputs: Wc_Tut_Save_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File → Export → PDF creates a PDF with real, selectable text, working links and bookmarks.`)
};

/**
* | output |
* | --- |
* | "File → Export → PDF creates a PDF with real, selectable text, working links and bookmarks." |
*
* @param {Wc_Tut_Save_P2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_save_p2 = /** @type {((inputs?: Wc_Tut_Save_P2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Save_P2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_save_p2(inputs)
});
export { wc_tut_save_p2 as "wc.tut.save.p2" }